"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_VOLUME_RATIOS = exports.DEFAULT_VOLUME = void 0;
const DEFAULT_VOLUME_RATIOS = exports.DEFAULT_VOLUME_RATIOS = {
  VIDEO: 0.7,
  MUSIC: 0.25,
  VOCAL_TRACK: 0.8,
  EFFECTS: 0.7,
  AMBIANCE: 0.35
};
const DEFAULT_VOLUME = exports.DEFAULT_VOLUME = 0.75;